(function () {
    'use strict';

    angular.module("imApp").factory("priceIndexMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 3223,
                    parameters: parms || {}
                });
            },
            createObj: function (edit) {
                return $ihttp.post({
                    method: 3227,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
